import React, { Component } from 'react';
import { actions } from '../../config/reduxIndex';
import { connect } from 'react-redux';
import LoginForm from '../../components/login/LoginForm';

/**
 * Renders: {@link LoginForm}
 * @props login - redux -> state.login
 * @props {function} loginSubmit - redux -> login.loginSubmit()
 * @returns LoginForm
 */
class LoginFormContainer extends Component {
	state = {
		'username': process.env.REACT_APP_USER,
		'password': process.env.REACT_APP_PASSWORD,
		'password1': '',
		'password2': ''
	};
	
	login = () => {
		const { loginSubmit, defaultRoutePostLogin } = this.props;
		const submitObj = Object.assign({}, this.state, {defaultRoutePostLogin})
		loginSubmit(submitObj);
	};
	
	setInput = (e) => {
		const attr = e.target.getAttribute('attr');
		this.setState({[attr]: e.target.value});
	};
	
	submitOnEnter = (e) => {
		if(e.keyCode === 13) {
			this.login();
		}
	};
	
	render() {
		const { changePass } = this.props.login;
		return <LoginForm 
			changePass = {changePass}
			setInput = {this.setInput}
			submitOnEnter = {this.submitOnEnter}
			username = {this.state.username}
			password = {this.state.password}
			loginSubmit = {this.login}
		/>
		
	}
}

function mapStateToProps(state) { 
	return {
		login: state.login
	}; 
} 


const mapDispatchToProps = dispatch => {
	return {
		loginSubmit: (loginObj) => {
			dispatch(actions.login.loginSubmit(loginObj))
		}
	}
}; 

LoginFormContainer.defaultProps = {
	defaultRoutePostLogin: false
};

LoginFormContainer = connect(mapStateToProps, mapDispatchToProps)(LoginFormContainer);
export default LoginFormContainer;


// WEBPACK FOOTER //
// ./src/containers/login/LoginFormContainer.js